import "./assets/base.scss";
import "./assets/extras.scss";

import { createPinia } from "pinia";
import { createApp, defineCustomElement } from "vue";

import App from "./App.vue";
import router from "./router";

import Sortable from "sortablejs";
import VueFeather from "vue-feather";
// import Tres from "@tresjs/core";

// console.debug("Starting app...");

// create app
const app = createApp(App);
const isDev = import.meta.env.MODE === "development";

app.use(createPinia()); // for state management
app.use(router); // for routing
// app.use(Tres);

// Register drag'n'drop/sortable directive
app.directive("sortable", {
  mounted(el, binding) {
    try {
      new Sortable(el, binding.value || {});
    } catch (error) {
      console.error("Error initializing Sortable:", error);
    }
  },
});

// Register feather icons
const VIC = defineCustomElement(VueFeather, {
  shadowRoot: false, // disable shadowroot, as it breaks the icons height and width
});
customElements.define("v-icon", VIC);

app.mount("#app");

if (isDev) console.debug("App started", import.meta.env);
